import { Box, Button, Card, Divider, Link, Stack } from '@mui/material'
import React from 'react'
import { ReactComponent as Books } from "../assets/svg/books_menu.svg";
import { ReactComponent as Favorite } from "../assets/svg/star_menu.svg";
import { ReactComponent as Notification } from "../assets/svg/notif_menu.svg";
import { ReactComponent as Settings } from "../assets/svg/settings_menu.svg";
export default function Menu() {
    const divider = (
        <Divider variant="middle" sx={{ marginTop: 2 }} />
    )
    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            },

        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        linkTexts: {
            textTransform: "none",
            color: (theme) => theme.palette.text.primary,
            fontWeight: "bold",
            fontSize: 18,
            "&: hover": {
                color: (theme) => theme.palette.primary.main,
                backgroundColor: "transparent"
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        cardDashboard: {
            borderRadius: 0,
            boxShadow: 0,
            minHeight: 90,
            opacity: 0.9
        },
        actionButton: {
            margin: 0,
            padding: 1,
            height: 23,
            backgroundColor: "#B9E291",
            boxShadow: 0,
            borderRadius: 0,
            fontSize: 12,
        },
        scrollableDiv: {
            maxHeight: "100vh",
            '@media only screen and (min-width: 1700px)': {
                height: 700
            },
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            overflow: 'auto',
            //for other browsers 
            scrollbarWidth: "none"
        },
        sideDiv: {
            position: "sticky",
            height: 500

        },
    }
    return (
        <Box sx={style.sideDiv}>
            <Card variant="outlined" sx={{ height: "100%", maxHeight: 500 }}>
                <Stack direction="column" spacing={4} sx={{ marginTop: "25%", paddingRight: 2.5, paddingLeft: 2.5 }}>
                    <Stack direction="row" spacing={2} alignItems="center"  >
                        <Box variant="square" sx={{ height: 45, width: 45 }}>
                            <Books style={{ width: "inherit", height: "inherit" }} />
                        </Box>
                        <Link href="/mybooks/reserve" sx={{ textDecoration: "none" }}>
                            <Button disableRipple sx={style.linkTexts}>
                                My Books
                            </Button>
                        </Link>
                    </Stack>
                    {divider}
                    <Stack direction="row" spacing={2} alignItems="center" >
                        <Box variant="square" sx={{ height: 45, width: 45 }}>
                            <Favorite style={{ width: "inherit", height: "inherit" }} />
                        </Box>
                        <Link href="/bookmarks" sx={{ textDecoration: "none" }}>
                            <Button disableRipple sx={style.linkTexts}>
                                Bookmarks
                            </Button>
                        </Link>
                    </Stack>
                    {divider}
                    <Stack direction="row" spacing={2} alignItems="center" >
                        <Box variant="square" sx={{ height: 45, width: 45 }}>
                            <Notification style={{ width: "inherit", height: "inherit" }} />
                        </Box>
                        <Link href="/notifications" sx={{ textDecoration: "none" }}>
                            <Button disableRipple sx={style.linkTexts}>
                                Notifications
                            </Button>
                        </Link>
                    </Stack>
                    {divider}
                    <Stack direction="row" spacing={2} alignItems="center" >
                        <Box variant="square" sx={{ height: 45, width: 45 }}>
                            <Settings style={{ width: "inherit", height: "inherit" }} />
                        </Box>
                        <Link href="/settings" sx={{ textDecoration: "none" }}>
                            <Button disableRipple sx={style.linkTexts}>
                                Settings
                            </Button>
                        </Link>
                    </Stack>
                </Stack>

            </Card>
        </Box>
    )
}
